export const THEME_STORAGE_KEY = "bookbuddy.theme";
export const DEFAULT_THEME_KEY = "darkacademia";

export function readStoredTheme(themes, fallback = DEFAULT_THEME_KEY) {
  if (typeof window === "undefined") return fallback;
  try {
    const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (storedTheme && themes?.[storedTheme]) return storedTheme;
  } catch {
    // Ignore storage failures and fall back to the default theme.
  }
  return fallback;
}

export function writeStoredTheme(themeKey) {
  if (typeof window === "undefined" || !themeKey) return;
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, themeKey);
  } catch {
    // Ignore storage failures so startup stays resilient.
  }
}
